// extracted by mini-css-extract-plugin
export default {"recos":"F4-z","productCardOverride":"G4-z","rowHasBadge":"H4-z"};